
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref645"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref645"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dX9AK", function(module, exports) {

$parcel$export(module.exports, "parseDay", () => $4abb5bd8e9b62992$export$499b1eca6837bd4);
$parcel$export(module.exports, "initOpeningNotice", () => $4abb5bd8e9b62992$export$3feded53dc0a6714);
// Hinweis-Fenster eines Standorts (Inhalt aus src/data/hinweis_*.json, gepflegt über /admin).
// Erscheint nur im Zeitraum data-von/data-bis und nur einmal pro Besucher,
// bis sich der Inhalt ändert.
const $4abb5bd8e9b62992$var$DISMISSED_KEY = 'opening-notice-dismissed';
function $4abb5bd8e9b62992$export$499b1eca6837bd4(value, endOfDay) {
    if (!value) return null;
    const day = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (day) return new Date(+day[1], +day[2] - 1, +day[3] + (endOfDay ? 1 : 0)).getTime();
    const time = Date.parse(value);
    return Number.isNaN(time) ? null : time;
}
function $4abb5bd8e9b62992$var$isInPeriod(dialog) {
    const now = Date.now();
    const from = $4abb5bd8e9b62992$export$499b1eca6837bd4(dialog.dataset.von, false);
    const until = $4abb5bd8e9b62992$export$499b1eca6837bd4(dialog.dataset.bis, true);
    return (from === null || now >= from) && (until === null || now < until);
}
// Kurzer Fingerabdruck des Inhalts, damit ein geänderter Hinweis wieder erscheint.
function $4abb5bd8e9b62992$var$contentHash(text) {
    let hash = 5381;
    for(let i = 0; i < text.length; i++)hash = hash * 33 ^ text.charCodeAt(i);
    return (hash >>> 0).toString(36);
}
function $4abb5bd8e9b62992$var$readDismissed() {
    try {
        return localStorage.getItem($4abb5bd8e9b62992$var$DISMISSED_KEY);
    } catch  {
        return null;
    }
}
function $4abb5bd8e9b62992$var$saveDismissed(hash) {
    try {
        localStorage.setItem($4abb5bd8e9b62992$var$DISMISSED_KEY, hash);
    } catch  {}
}
function $4abb5bd8e9b62992$export$3feded53dc0a6714() {
    const dialog = document.querySelector('#opening-notice');
    if (!dialog || !$4abb5bd8e9b62992$var$isInPeriod(dialog)) return;
    // Use the same hours as the existing panel so future edits stay in sync.
    const hours = dialog.querySelector('.opening-notice-hours');
    const source = document.querySelector('#opening-hours-panel');
    if (hours && source) hours.replaceChildren(...Array.from(source.querySelectorAll('ul'), (list)=>list.cloneNode(true)));
    const hash = $4abb5bd8e9b62992$var$contentHash((dialog.textContent || '').replace(/\s+/g, ' ').trim());
    if ($4abb5bd8e9b62992$var$readDismissed() === hash) return;
    dialog.addEventListener('close', ()=>{
        document.documentElement.classList.remove('opening-notice-visible');
        $4abb5bd8e9b62992$var$saveDismissed(hash);
    });
    dialog.addEventListener('click', (event)=>{
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.showModal();
    document.documentElement.classList.add('opening-notice-visible');
}

});

// Content load handler
// - Fügt Klassen bei DOMContentLoaded / load hinzu
// - Lazy-load für Elemente mit `data-src`
// - Preloader (#preloader) bleibt, bis das Hero-Video ein erstes Bild hat
// Lazy Loading Handler
// - Lazy-load für Elemente mit `data-src`
// - Verwendet IntersectionObserver für Performance
// - Video-Setup für proxy loading via HTML
// Speichern der gehashten Video-Pfade pro Video (Map für mehrere Videos)
const $32a3a3f71f269bc5$var$videoSourcesMap = new Map();
// Bereits gestartete Videos (Hero-Video startet früher als die übrigen)
const $32a3a3f71f269bc5$var$startedVideos = new WeakSet();
const $32a3a3f71f269bc5$var$PAUSE_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>';
const $32a3a3f71f269bc5$var$PLAY_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';
function $32a3a3f71f269bc5$var$isImage(el) {
    return el.tagName.toLowerCase() === 'img';
}
function $32a3a3f71f269bc5$var$loadResource(el) {
    return new Promise((resolve)=>{
        if ($32a3a3f71f269bc5$var$isImage(el)) {
            const img = el;
            const src = img.dataset.src;
            if (!src) return resolve();
            img.onload = ()=>img.classList.add('loaded');
            img.onerror = ()=>img.classList.add('error');
            img.src = src;
            delete img.dataset.src;
            return resolve();
        }
        const src = el.getAttribute('data-src');
        if (src) {
            if (el instanceof HTMLIFrameElement) el.src = src;
            else el.setAttribute('style', (el.getAttribute('style') || '') + `background-image:url('${src}')`);
            el.removeAttribute('data-src');
        }
        resolve();
    });
}
function $32a3a3f71f269bc5$export$c3bf910d26c7ca3b() {
    const videos = document.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;
    videos.forEach((video)=>{
        // Dekoratives Video ohne Ton: für Screenreader ausblenden.
        // Gestartet wird per setupLazyVideos(), nicht per autoplay-Attribut.
        video.setAttribute('aria-hidden', 'true');
        video.autoplay = false;
        const sources = {
            desktop: {},
            mobile: {}
        };
        Array.from(video.querySelectorAll('source')).forEach((source)=>{
            const src = source.getAttribute('src');
            const type = source.getAttribute('type') || '';
            if (!src) return;
            const isMobile = source.getAttribute('data-mobile') === 'true';
            if (isMobile) sources.mobile[type] = src;
            else sources.desktop[type] = src;
            // src entfernen, damit Video nicht sofort geladen wird
            source.removeAttribute('src');
        });
        $32a3a3f71f269bc5$var$videoSourcesMap.set(video, sources);
    });
}
function $32a3a3f71f269bc5$export$4b2fb9f4f3c864ee(only) {
    const isMobile = window.matchMedia('(max-width:768px)').matches;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $32a3a3f71f269bc5$var$videoSourcesMap.forEach((sources, video)=>{
        if (only && !only.includes(video)) return;
        if ($32a3a3f71f269bc5$var$startedVideos.has(video)) return;
        $32a3a3f71f269bc5$var$startedVideos.add(video);
        const variant = isMobile ? sources.mobile : sources.desktop;
        Array.from(video.querySelectorAll('source')).forEach((source)=>{
            const type = source.getAttribute('type') || '';
            if (variant[type]) source.setAttribute('src', variant[type]);
        });
        if (reduceMotion) {
            // "Bewegung reduzieren": nur das erste Bild zeigen, abspielen per Button
            video.preload = 'auto';
            video.load();
        } else {
            video.load();
            video.play().catch(()=>{});
        }
        $32a3a3f71f269bc5$var$addVideoToggle(video);
    });
}
/**
 * Anhalten/Abspielen-Button für ein Video (WCAG 2.2.2: bewegte Inhalte,
 * die länger als 5 Sekunden laufen, müssen sich anhalten lassen)
 */ function $32a3a3f71f269bc5$var$addVideoToggle(video) {
    const wrapper = video.parentElement;
    if (!wrapper || wrapper.querySelector('.video-toggle')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'video-toggle';
    const update = ()=>{
        button.setAttribute('aria-label', video.paused ? 'Video abspielen' : 'Video anhalten');
        button.innerHTML = video.paused ? $32a3a3f71f269bc5$var$PLAY_ICON : $32a3a3f71f269bc5$var$PAUSE_ICON;
    };
    button.addEventListener('click', ()=>{
        if (video.paused) video.play().catch(()=>{});
        else video.pause();
    });
    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    update();
    wrapper.append(button);
}
function $32a3a3f71f269bc5$export$c041b30aa95b625b(video, maxWait) {
    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA || maxWait <= 0) return Promise.resolve();
    return new Promise((resolve)=>{
        let timer = 0;
        const done = ()=>{
            window.clearTimeout(timer);
            resolve();
        };
        timer = window.setTimeout(done, maxWait);
        video.addEventListener('loadeddata', done, {
            once: true
        });
    });
}
function $32a3a3f71f269bc5$export$3b98fa096e9fc203(root = document) {
    return new Promise((resolve)=>{
        const nodes = Array.from(root.querySelectorAll('[data-src]'));
        if (!nodes.length) {
            resolve();
            return;
        }
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries, obs)=>{
                entries.forEach((entry)=>{
                    if (!entry.isIntersecting) return;
                    const el = entry.target;
                    $32a3a3f71f269bc5$var$loadResource(el).catch(()=>{});
                    obs.unobserve(entry.target);
                });
            }, {
                root: null,
                threshold: 0
            });
            nodes.forEach((n)=>io.observe(n));
            resolve(); // IntersectionObserver Setup fertig
        } else // Fallback: load all immediately
        Promise.all(nodes.map((n)=>$32a3a3f71f269bc5$var$loadResource(n))).then(()=>resolve()).catch(()=>resolve());
    });
}


// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset
function $e745b9ef5c505b0a$var$smoothScrollToTarget(href) {
    // Anchor href auslesen
    if (!href.startsWith('#')) return;
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    // Topbar-Höhe ermitteln
    const topbar = document.querySelector('.fuelpipe-topbar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;
    // Scroll-Position berechnen
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight - 16;
    // Smooth Scroll ausführen (bei "Bewegung reduzieren" direkt springen)
    window.scrollTo({
        top: targetPosition,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
}
function $e745b9ef5c505b0a$export$b61d4be8ddba9539() {
    const currentPage = window.location.pathname.split('/').pop();
    const practiceLabel = document.querySelector('[data-practice-label]');
    const currentPractice = document.querySelector(`.practice-switcher .dropdown a[href="${currentPage === 'roelsdorf.html' ? 'roelsdorf.html' : 'dueren.html'}"]`);
    if (practiceLabel && currentPractice && (currentPage === 'dueren.html' || currentPage === 'roelsdorf.html')) {
        practiceLabel.textContent = currentPractice.textContent;
        currentPractice.classList.add('active-practice');
        currentPractice.setAttribute('aria-current', 'page');
    }
    document.querySelector('.practice-switcher .active-practice:not([aria-current])')?.setAttribute('aria-current', 'true');
    const toggle = document.querySelector('.menu-toggle');
    const backdrop = document.querySelector('.menu-backdrop');
    const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');
    if (!toggle || !backdrop) return;
    const toggleMenu = ()=>{
        const isOpen = document.body.classList.toggle('nav-open');
        toggle.classList.toggle('active');
        toggle.setAttribute('aria-expanded', String(isOpen));
        toggle.setAttribute('aria-label', isOpen ? "Men\xfc schlie\xdfen" : "Men\xfc \xf6ffnen");
    };
    // Escape schließt das mobile Menü und gibt den Fokus an den Menü-Button zurück
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
            toggleMenu();
            toggle.focus();
        }
    });
    // Dropdown click handling
    const dropdownItems = document.querySelectorAll('li.has-dropdown');
    dropdownItems.forEach((item)=>{
        const trigger = item.querySelector(':scope > a, :scope > button');
        if (!trigger) return;
        // Aufklapp-Navigation (Disclosure), kein ARIA-Menü: daher nur aria-expanded, kein aria-haspopup
        trigger.setAttribute('aria-expanded', 'false');
        const toggleDropdown = (open)=>{
            const isOpen = open !== undefined ? open : !item.classList.contains('dropdown-open');
            item.classList.toggle('dropdown-open', isOpen);
            trigger.setAttribute('aria-expanded', String(isOpen));
        };
        trigger.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
            // Close other open dropdowns
            dropdownItems.forEach((other)=>{
                if (other !== item) {
                    other.classList.remove('dropdown-open');
                    const otherTrigger = other.querySelector(':scope > a, :scope > button');
                    if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
                }
            });
        });
        // Escape-Taste schließt das Dropdown
        item.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') {
                toggleDropdown(false);
                trigger.focus();
            }
        });
    });
    // Close dropdown on outside click
    document.addEventListener('click', ()=>{
        dropdownItems.forEach((item)=>{
            item.classList.remove('dropdown-open');
            const trigger = item.querySelector(':scope > a, :scope > button');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
    });
    toggle.addEventListener('click', (e)=>{
        e.stopPropagation();
        toggleMenu();
    });
    backdrop.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            if (link.matches('li.has-dropdown > a')) return;
            const href = link.getAttribute('href');
            // Wenn es ein Anker ist, smooth scroll triggern
            if (href?.startsWith('#')) {
                e.preventDefault();
                $e745b9ef5c505b0a$var$smoothScrollToTarget(href);
            }
            // Menü schließen wenn offen
            if (document.body.classList.contains('nav-open')) toggleMenu();
        });
    });
}


// Scroll Animations Handler
// - Element-basierte Animationen
// - Jedes Element mit [data-animate] triggert unabhängig
// - Respektive auch bei langen Sections früh auslösen
function $b611819413d23cbb$export$4ae6feb6159b4594() {
    const animatedElements = document.querySelectorAll('[data-animate]');
    if (!animatedElements.length) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const element = entry.target;
            const customDelay = parseFloat(element.getAttribute('data-delay') || '0') * 1000; // in ms
            element.style.animationDelay = `${customDelay}ms`;
            element.classList.add('animate-in');
            // Element nach Animation nicht mehr beobachten
            observer.unobserve(element);
        });
    }, {
        threshold: 0.1
    });
    // Alle animierten Elemente beobachten
    animatedElements.forEach((element)=>{
        observer.observe(element);
    });
}


// Scroll Morph Handler
// - Überblendung zwischen .normal und .morph Bildern gekoppelt an Scroll-Fortschritt
// - Beginn: Element in Bildschirmmitte
// - Ende: Element am oberen Rand (minus Topbar-Höhe)
// - Bidirektional: Vorwärts und Rückwärts-Scrollen funktioniert
const $042d2a1a583b6f8f$var$TOPBAR_HEIGHT = 80; // px - CSS @topbar-height
function $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c() {
    const morphContainers = document.querySelectorAll('.foto-morph');
    if (!morphContainers.length) return;
    const configs = Array.from(morphContainers).map((container)=>{
        const morphImg = container.querySelector('img.morph');
        return {
            container: container,
            morphImg: morphImg
        };
    }).filter((config)=>config.morphImg);
    if (!configs.length) return;
    // Update Morph-Opacity kontinuierlich beim Scroll
    const updateMorphOpacity = ()=>{
        configs.forEach(({ container: container, morphImg: morphImg })=>{
            // Bounding Rect vom Container
            const rect = container.getBoundingClientRect();
            const containerCenter = rect.top; // + rect.height / 2;
            const isMobile = window.matchMedia('(max-width:768px)').matches;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            const startPoint = isMobile ? viewportHeight * 0.45 - 100 : viewportHeight * 0.45; // Bildschirmmitte
            const endPoint = isMobile ? $042d2a1a583b6f8f$var$TOPBAR_HEIGHT : $042d2a1a583b6f8f$var$TOPBAR_HEIGHT + 100; // Oberer Rand minus Topbar
            // Scroll-Fortschritt berechnen (0 = Start, 1 = Ende)
            // Wenn Container-Mitte in Bildschirmmitte ist: progress = 0
            // Wenn Container-Mitte am oberen Rand ist: progress = 1
            const distanceFromMidpoint = startPoint - containerCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let progress = distanceFromMidpoint / activationRange;
            progress = Math.max(0, Math.min(1, progress));
            // Opacity setzen (nur für .morph Bild)
            morphImg.style.opacity = String(progress);
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateMorphOpacity();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


// Scroll Heading Handler
// - Zerlegt .heading h2 in einzelne Wörter
// - Animiert Wörter einzeln beim Scrollen (blur + skew + opacity)
// - Start: wenn h2 sichtbar wird (unten im Viewport)
// - Ende: wenn h2 oberhalb der Bildschirmmitte
function $0e5e9a9af84e2131$export$c80c5dc5e82459e5() {
    const headings = document.querySelectorAll('.heading h2[data-animate]');
    if (!headings.length) return;
    const configs = Array.from(headings).map((h2)=>{
        const heading = h2.closest('.heading');
        if (!heading) return null;
        const originalText = h2.textContent || '';
        const words = originalText.trim().split(/\s+/);
        // h2 leeren und mit Spans füllen
        h2.innerHTML = '';
        const wordSpans = words.map((word)=>{
            const span = document.createElement('span');
            span.textContent = word;
            span.style.display = 'inline-block';
            span.style.marginRight = '0.3em';
            span.style.willChange = 'filter, transform, opacity';
            h2.appendChild(span);
            return {
                span: span
            };
        });
        return {
            heading: heading,
            h2: h2,
            wordSpans: wordSpans
        };
    }).filter((config)=>config !== null);
    if (!configs.length) return;
    // Update Heading-Animation kontinuierlich beim Scroll
    const updateHeadingAnimation = ()=>{
        configs.forEach(({ heading: heading, wordSpans: wordSpans })=>{
            // Bounding Rect vom Heading
            const rect = heading.getBoundingClientRect();
            const headingCenter = rect.top + rect.height / 2;
            // Viewpoint-Breiten
            const viewportHeight = window.innerHeight;
            // Start: Element kommt unten in Sicht (viewportHeight)
            // Ende: Element ist oberhalb der Bildschirmmitte (viewportHeight / 2)
            const startPoint = viewportHeight; // Unten - Animation beginnt
            const endPoint = viewportHeight / 2; // Mitte - Animation abgeschlossen
            // Fortschritt je näher Element nach oben kommt
            const distanceFromMidpoint = startPoint - headingCenter;
            const activationRange = startPoint - endPoint;
            // Fortschritt clamped zwischen 0 und 1
            let overallProgress = distanceFromMidpoint / activationRange;
            overallProgress = Math.max(0, Math.min(1, overallProgress));
            // Berechne gesamte Stagger-Verzögerung (vom ersten bis letzten Wort)
            const totalWordDelay = (wordSpans.length - 1) * 0.08;
            // Skaliere overallProgress so, dass die Animation über ALLE Wörter läuft
            const adjustedProgress = overallProgress * (1 + totalWordDelay);
            // Für jedes Wort: individueller Fortschritt
            wordSpans.forEach((word, index)=>{
                // Jedes Wort animiert mit Stagger-Effekt
                const wordDelay = index * 0.08; // 8% Stagger pro Wort
                // Fortschritt für dieses Wort (0 bis 1, mit Stagger)
                const wordProgress = Math.max(0, Math.min(1, adjustedProgress - wordDelay));
                // Interpoliere Blur-Effekt
                const blur = 8 * (1 - wordProgress); // Von 8px zu 0px
                const skew = -20 * (1 - wordProgress); // Von -20deg zu 0deg
                const opacity = wordProgress; // Von 0 zu 1
                // CSS anwenden
                word.span.style.filter = `blur(${blur}px)`;
                word.span.style.transform = `skew(${skew}deg)`;
                word.span.style.opacity = String(opacity);
            });
        });
    };
    // Mit requestAnimationFrame für optimale Performance
    const animationLoop = ()=>{
        updateHeadingAnimation();
        requestAnimationFrame(animationLoop);
    };
    animationLoop();
}


const $cbfc1906568eddda$var$COUNT_DURATION = 1500;
const $cbfc1906568eddda$var$COUNT_START_DELAY = 900;
function $cbfc1906568eddda$var$animateCount(element) {
    const target = Number(element.dataset.countTo);
    const suffix = element.dataset.countSuffix || '';
    if (!Number.isFinite(target)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.textContent = `${target}${suffix}`;
        return;
    }
    function startAnimation() {
        const startTime = performance.now();
        function update(currentTime) {
            const progress = Math.min((currentTime - startTime) / $cbfc1906568eddda$var$COUNT_DURATION, 1);
            const currentValue = progress < 1 ? Math.floor(target * progress) : target;
            element.textContent = `${currentValue}${suffix}`;
            if (progress < 1) requestAnimationFrame(update);
        }
        requestAnimationFrame(update);
    }
    window.setTimeout(startAnimation, $cbfc1906568eddda$var$COUNT_START_DELAY);
}
function $cbfc1906568eddda$export$9bf800baa41ee236() {
    const intro = document.getElementById('intro');
    if (!intro) return;
    const counters = intro.querySelectorAll('[data-count-to]');
    if (!counters.length) return;
    counters.forEach((counter)=>{
        counter.textContent = `0${counter.dataset.countSuffix || ''}`;
    });
    const observer = new IntersectionObserver((entries)=>{
        if (!entries.some((entry)=>entry.isIntersecting)) return;
        counters.forEach($cbfc1906568eddda$var$animateCount);
        observer.disconnect();
    }, {
        threshold: 0.25
    });
    observer.observe(intro);
}



var $dX9AK = parcelRequire("dX9AK");
// Längste Wartezeit des Preloaders auf das Hero-Video, gerechnet ab Seitenaufruf
const $e366f2c43bf887ab$var$PRELOADER_MAX_WAIT = 4000;
function $e366f2c43bf887ab$var$hidePreloader() {
    // .loaded blendet den Preloader per CSS aus, danach wird er entfernt
    document.documentElement.classList.add('loaded');
    document.body.classList.add('loaded');
    const pre = document.getElementById('preloader');
    if (pre) window.setTimeout(()=>pre.remove(), 400);
}
function $e366f2c43bf887ab$var$initHeroAnimation() {
    document.querySelectorAll('#teaser-index, #teaser').forEach((teaser)=>{
        teaser.classList.add('animate-in');
    });
}
function $e366f2c43bf887ab$var$initOpeningHoursToggle() {
    const icon = document.querySelector('.opening-hours-icon');
    const panel = document.querySelector('#opening-hours');
    if (!icon || !panel) return;
    const setOpen = (open)=>{
        panel.classList.toggle('open', open);
        icon.setAttribute('aria-expanded', String(open));
    };
    // Echter <button>: Enter und Leertaste lösen den Klick von selbst aus
    icon.addEventListener('click', ()=>setOpen(!panel.classList.contains('open')));
    // Escape schließt das Panel und gibt den Fokus an den Button zurück
    panel.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && panel.classList.contains('open')) {
            setOpen(false);
            icon.focus();
        }
    });
}
function $e366f2c43bf887ab$var$onDOMContentLoaded() {
    document.documentElement.classList.add('dom-ready');
    document.body.classList.add('dom-ready');
    // LazyLoad zuerst
    (0, $32a3a3f71f269bc5$export$3b98fa096e9fc203)(document);
    // Video-Pfade aus HTML auslesen und speichern
    (0, $32a3a3f71f269bc5$export$c3bf910d26c7ca3b)();
    // Hero-Video sofort laden, der Preloader wartet darauf
    const heroVideo = document.querySelector('#headerVideo');
    if (heroVideo) (0, $32a3a3f71f269bc5$export$4b2fb9f4f3c864ee)([
        heroVideo
    ]);
    (0, $e745b9ef5c505b0a$export$b61d4be8ddba9539)();
    $e366f2c43bf887ab$var$initOpeningHoursToggle();
}
async function $e366f2c43bf887ab$var$onWindowLoad() {
    // Preloader erst ausblenden, wenn das Hero-Video ein Bild hat (höchstens PRELOADER_MAX_WAIT)
    const heroVideo = document.querySelector('#headerVideo');
    if (heroVideo) await (0, $32a3a3f71f269bc5$export$c041b30aa95b625b)(heroVideo, $e366f2c43bf887ab$var$PRELOADER_MAX_WAIT - performance.now());
    $e366f2c43bf887ab$var$hidePreloader();
    // Hero-Animation sofort triggern
    $e366f2c43bf887ab$var$initHeroAnimation();
    // Animationen erst NACH Preloader-Entfernung
    (0, $b611819413d23cbb$export$4ae6feb6159b4594)();
    (0, $cbfc1906568eddda$export$9bf800baa41ee236)();
    // Scroll-Morph initialisieren
    (0, $042d2a1a583b6f8f$export$4ccdd715a2b7fd1c)();
    // Scroll-Heading initialisieren
    (0, $0e5e9a9af84e2131$export$c80c5dc5e82459e5)();
    // Übrige Videos (z. B. Logo-Video) erst jetzt laden
    (0, $32a3a3f71f269bc5$export$4b2fb9f4f3c864ee)();
    // Hinweis-Fenster erst zeigen, wenn der Preloader weg ist
    (0, $dX9AK.initOpeningNotice)();
}
function $e366f2c43bf887ab$export$c1e92a604cbf4acd() {
    if (document.readyState === 'complete') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        $e366f2c43bf887ab$var$onWindowLoad();
        return;
    }
    if (document.readyState === 'interactive') {
        $e366f2c43bf887ab$var$onDOMContentLoaded();
        window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
            once: true
        });
        return;
    }
    window.addEventListener('DOMContentLoaded', $e366f2c43bf887ab$var$onDOMContentLoaded, {
        once: true
    });
    window.addEventListener('load', $e366f2c43bf887ab$var$onWindowLoad, {
        once: true
    });
}
// Auto-init when module is imported
$e366f2c43bf887ab$export$c1e92a604cbf4acd();


//# sourceMappingURL=app.96565605.js.map
